<template>
  <el-divider class="blue-divider" style="margin-top: 40px; margin-bottom: 40px"/>
  <el-table
      :data="tableData"
      style="width: 100%;"
      :summary-method="getTotalSummary"
      :show-summary="true"
  >
    <el-table-column prop="name" label=" "/>
    <el-table-column label="Кол-во для тарификации" prop="amount"/>
    <el-table-column label="Расходы" :formatter="r => formatNumber(r.spent, '.', r.__precision)"/>

  </el-table>
</template>

<script>
export default {
  name: 'GlobalSummaryDetailedReportTable',
  props: ["tableData"],
  methods: {
    getTotalSummary() {
      return [
        "Общий итог",
        this.tableData[0].amount + this.tableData[1].amount + this.tableData[2].amount,
        this.formatNumber(this.tableData[0].spent + this.tableData[1].spent + this.tableData[2].spent + +this.tableData[3].spent)
        // (this.generalStatistics.names.totalNames || 0) + this.generalStatistics.call.sent + this.generalStatistics.sms.sent,

        // this.formatNumber(
        //     (this.generalStatistics.names.spent || 0) + (
        //         (this.generalStatistics.call.spent + this.generalStatistics.sms.spent + this.generalStatistics.vk.spent + this.generalStatistics.telegram.spent + this.generalStatistics.whatsapp.spent) || 0)
        // )
      ]
    }
  }
}
</script>